export const grants = {
  READ: 'read',
  CREATE: 'create',
  UPDATE: 'update',
};

export const subjects = {
  CONFIGURATION: 'configuration',
};
